import { TextInput } from "@strapi/design-system";
import { Grid, GridItem } from "@strapi/design-system/Grid";
import { Typography } from "@strapi/design-system/Typography";
import { Button, DatePicker, message, Radio } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { updateNominator } from "../util/API";
import {
  dateFormatList,
  isStrEmpty,
  isValidEmail,
  isValidPhoneNumber,
} from "../util/helper";
import DegreeSelect from "./degreeSelect";
import { Field, FieldError, FieldLabel } from "@strapi/design-system";
const Nominator = ({
  userInfo,
  disabled = false,
  isSecretariatView = false,
  api_path = "",
}) => {
  const { t } = useTranslation();
  const [dataForUpdate, setDataForUpdate] = useState(userInfo ? userInfo : {});
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (!dataForUpdate?.id && userInfo) setDataForUpdate(userInfo);
  }, [userInfo]);

  if (!userInfo) {
    return <div>Loading...</div>;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      try {
        if (
          !dataForUpdate?.dob ||
          dataForUpdate?.dob === null ||
          dataForUpdate?.dob === ""
        ) {
          setDataForUpdate({
            ...dataForUpdate,
            dob: dayjs().format("YYYY-MM-DD"),
          });
        }

        const checkValid = isValid();
        if (!checkValid) {
          messageApi.open({
            type: "error",
            content: t("str_fill_in_all_info"),
          });
          return;
        }

        const checkEmailValid = isValidEmail(dataForUpdate?.email);
        if (!checkEmailValid) {
          messageApi.open({
            type: "error",
            content: t("str_email_invalid"),
          });
          return;
        }


        const response = await updateNominator(api_path, dataForUpdate);

        if (response.status === 200) {
          messageApi.open({
            type: "success",
            content: `${t("str_save_success")}`,
          });
        }
        return;
      } catch (error) {}
    } catch (error) {
      console.error(error.response.data);
    }
  };

  const handleSetDob = (date, dateString) => {
    setDataForUpdate({
      ...dataForUpdate,
      dob: dayjs(date).format(dateFormatList[1]),
    });
  };

  const isValid = () => {
    if (isStrEmpty(dataForUpdate?.name)) return false;
    if (isStrEmpty(dataForUpdate?.email)) return false;
    if (!dataForUpdate?.is_org && isStrEmpty(dataForUpdate?.degree))
      return false;

    return true;
  };

  //#region Handle update info
  const handleSetName = (name) => {
    setDataForUpdate({
      ...dataForUpdate,
      name,
    });
  };

  const handleSetAddress = (address) => {
    setDataForUpdate({
      ...dataForUpdate,
      address,
    });
  };

  const handleSetPhone = (phone) => {
    const formattedPhoneNumber = phone.replace(/[^0-9+\-().\s]/g, "");

    setDataForUpdate({
      ...dataForUpdate,
      phone: formattedPhoneNumber,
    });
  };

  const handleSetEmail = (email) => {
    setDataForUpdate({
      ...dataForUpdate,
      email,
    });
  };

  const handleSetDegree = (degree) => {
    setDataForUpdate({
      ...dataForUpdate,
      degree,
    });
  };

  const handleSetSpecialization = (specialization) => {
    setDataForUpdate({
      ...dataForUpdate,
      specialization,
    });
  };

  const handleSetWorkingUnit = (working_unit) => {
    setDataForUpdate({
      ...dataForUpdate,
      working_unit,
    });
  };

  const handleSetHomepageWorkingUnit = (homepage_working_unit) => {
    setDataForUpdate({
      ...dataForUpdate,
      homepage_working_unit,
    });
  };

  const handleSetAddressWorkingUnit = (address_working_unit) => {
    setDataForUpdate({
      ...dataForUpdate,
      address_working_unit,
    });
  };

  const handleSetRepresentativeEmail = (representative_email) => {
    setDataForUpdate({
      ...dataForUpdate,
      representative_email,
    });
  };

  const handleSetRepresentativePhone = (representative_phone) => {
    setDataForUpdate({
      ...dataForUpdate,
      representative_phone,
    });
  };

  const handleSetRepresentativeName = (representative_name) => {
    setDataForUpdate({
      ...dataForUpdate,
      representative_name,
    });
  };
  const handleSetGender = (gender) => {
    setDataForUpdate({
      ...dataForUpdate,
      gender,
    });
  };
  const handleSetPosition = (position) => {
    setDataForUpdate({
      ...dataForUpdate,
      position,
    });
  };
  //#endregion

  return (
    <div>
      {contextHolder}
      <div>
        <Grid gridCols={4} gap={5}>
          {/* 1.	Tên tổ chức đề cử */}
          <GridItem col={1} s={12} xs={12}>
            <TextInput
              name="name"
              label={
                dataForUpdate?.is_org
                  ? t("str_nominating_organization_name")
                  : t("str_nominator_name")
              }
              value={dataForUpdate?.name}
              onChange={(e) => handleSetName(e.target.value)}
              disabled={disabled}
            />
          </GridItem>

          {/* Tổ chức - hide */}
          {!dataForUpdate?.is_org && (
            <GridItem col={1} s={12} xs={12}>
              <Typography variant="pi" fontWeight="bold">
                {t("str_dob")}
              </Typography>
              <br />
              <DatePicker
                value={dataForUpdate?.dob ? dayjs(dataForUpdate?.dob) : null}
                format={dateFormatList[0]}
                placeholder="dd/mm/yyyy"
                className="custom-date-picker"
                onChange={handleSetDob}
                disabled={disabled}
              />
            </GridItem>
          )}
          {!dataForUpdate?.is_org && (
            <GridItem col={1} s={12} xs={12}>
              <Field
                name="gender"
                error={
                  !dataForUpdate?.gender || dataForUpdate?.gender === ""
                    ? t("str_required_gender")
                    : ""
                }
              >
                <FieldLabel style={{ marginBottom: "5px" }}>
                  {t("str_gender")}
                </FieldLabel>
                <Radio.Group
                  value={dataForUpdate?.gender}
                  onChange={(e) => handleSetGender(e.target.value)}
                  style={{ marginTop: "10px" }}
                  disabled={disabled}
                >
                  <Radio value="male">{t("str_male")}</Radio>
                  <Radio value="female">{t("str_female")}</Radio>
                </Radio.Group>

                <FieldError />
              </Field>
            </GridItem>
          )}

          {/* 2.	Địa chỉ tổ chức đề cử */}
          <GridItem col={1} s={12} xs={12}>
            <TextInput
              value={dataForUpdate?.address}
              name="address"
              label={
                dataForUpdate?.is_org
                  ? t("str_nomination_organization_address")
                  : t("str_contact_address")
              }
              onChange={(e) => handleSetAddress(e.target.value)}
              disabled={disabled}
            />
          </GridItem>

          {/* 3.	Số điện thoại tổ chức đề cử */}
          <GridItem col={1} s={12} xs={12}>
            <TextInput
              value={dataForUpdate?.phone}
              name="phone"
              label={
                dataForUpdate?.is_org
                  ? t("str_organization_phone_number")
                  : t("str_nominator_phone_number")
              }
              onChange={(e) => handleSetPhone(e.target.value)}
              disabled={disabled}
              pattern="^\+?[0-9]{1,4}[-\s.]?(\(?[0-9]+\)?[-\s.]?){4,}$" // Set the pattern attribute for HTML5 validation
            />
          </GridItem>

          {/* 4.	Email tổ chức đề cử */}
          <GridItem col={1} s={12} xs={12}>
            <TextInput
              value={dataForUpdate?.email}
              name="email"
              label={
                dataForUpdate?.is_org
                  ? t("str_organization_email")
                  : t("str_nominator_email")
              }
              onChange={(e) => handleSetEmail(e.target.value)}
              disabled={disabled}
            />
          </GridItem>

          {/* 5.	Người đại diện tổ chức đề cử 6.	Số điện thoại người đại diện tổ chức đề cử 7.	Email người đại diện tổ chức đề cử*/}
          {
            //#region Nominator --- !is_org
          }
          {!dataForUpdate?.is_org && (
            <GridItem col={1} s={12} xs={12}>
              <Typography variant="pi" fontWeight="bold">
                {t("str_nominator_academic_rank_degree")}
              </Typography>
              <br />
              <DegreeSelect
                lang={t("str_lang")}
                value={dataForUpdate?.degree}
                onChange={handleSetDegree}
                disabled={disabled}
              />
            </GridItem>
          )}

          {!dataForUpdate?.is_org && (
            <GridItem col={1} s={12} xs={12}>
              <TextInput
                value={dataForUpdate?.specialization}
                name="specialization"
                label={t("str_nominator_major")}
                onChange={(e) => handleSetSpecialization(e.target.value)}
                disabled={disabled}
              />
            </GridItem>
          )}

          {!dataForUpdate?.is_org && (
            <GridItem col={1} s={12} xs={12}>
              <TextInput
                value={dataForUpdate?.working_unit}
                name="working_unit"
                label={t("str_work_unit")}
                onChange={(e) => handleSetWorkingUnit(e.target.value)}
                disabled={disabled}
              />
            </GridItem>
          )}

          {!dataForUpdate?.is_org && (
            <GridItem col={1} s={12} xs={12}>
              <TextInput
                value={dataForUpdate?.address_working_unit}
                name="address_working_unit"
                label={t("str_workplace_address")}
                onChange={(e) => handleSetAddressWorkingUnit(e.target.value)}
                disabled={disabled}
              />
            </GridItem>
          )}

          {!dataForUpdate?.is_org && (
            <GridItem col={1} s={12} xs={12}>
              <TextInput
                value={dataForUpdate?.homepage_working_unit}
                name="homepage_working_unit"
                label={t("str_workplace_website")}
                onChange={(e) => handleSetHomepageWorkingUnit(e.target.value)}
                disabled={disabled}
              />
            </GridItem>
          )}

          {
            //#endregion
          }

          {
            //#region Nominator --- is_org
          }
          {dataForUpdate?.is_org && (
            <GridItem col={1} s={12} xs={12}>
              <TextInput
                value={dataForUpdate?.representative_name}
                name="representative_name"
                label={t("str_representative_nominating_organization")}
                onChange={(e) => handleSetRepresentativeName(e.target.value)}
                disabled={disabled}
              />
            </GridItem>
          )}

          {/* str_position */}
          {dataForUpdate?.is_org && (
            <GridItem col={1} s={12} xs={12}>
              {" "}
              <TextInput
                value={dataForUpdate?.position}
                name="position"
                label={t("str_position")}
                onChange={(e) => handleSetPosition(e.target.value)}
                disabled={disabled}
              />
            </GridItem>
          )}

          {dataForUpdate?.is_org && (
            <GridItem col={1} s={12} xs={12}>
              {" "}
              <TextInput
                value={dataForUpdate?.representative_phone}
                name="representative_phone"
                label={t("str_representative_phone_number")}
                onChange={(e) => handleSetRepresentativePhone(e.target.value)}
                pattern= "^\+?[0-9]{1,4}[-\s.]?(\(?[0-9]+\)?[-\s.]?){4,}$" // Set the pattern attribute for HTML5 validation
                disabled={disabled}
              />
            </GridItem>
          )}

          {dataForUpdate?.is_org && (
            <GridItem col={1} s={12} xs={12}>
              <TextInput
                value={dataForUpdate?.representative_email}
                name="representative_email"
                label={t("str_representative_email")}
                onChange={(e) => handleSetRepresentativeEmail(e.target.value)}
                disabled={disabled}
              />
            </GridItem>
          )}

          {
            //#endregion
          }
        </Grid>
      </div>
      <br />
      {!disabled && !isSecretariatView && (
        <Button onClick={handleSubmit} className="btnSave">
          {t("str_save")}
        </Button>
      )}
    </div>
  );
};

export default Nominator;
